import React from 'react';
import { RobbieMark } from '../ui';

/**
 * What the Robbie panel shows when a conversation opens cold: the mark, one
 * greeting line for the step the buyer is on, and nothing else. The suggestion
 * chips and the composer keep their own places in the panel footer, so this
 * fills the thread area rather than replacing the whole panel.
 *
 * The greeting is announced politely — it changes under the reader when the
 * panel wakes up or the wizard step moves, and a screen-reader user should
 * hear the new one without being yanked out of what they were doing.
 */
export interface RobbieRestingStateProps {
  greeting: string;
  className?: string;
}

export const RobbieRestingState: React.FC<RobbieRestingStateProps> = ({ greeting, className = '' }) => (
  <div className={`flex flex-1 flex-col items-center justify-center gap-s5 px-s4 py-s6 text-center ${className}`}>
    <RobbieMark size="lg" state="waving" aria-label="Robbie" />
    <p aria-live="polite" className="m-0 max-w-[240px] text-body-sm leading-[1.55] text-ink-body">
      {greeting}
    </p>
  </div>
);

export default RobbieRestingState;
